<template>
  <div class="flex flex-row items-center justify-center py-3">
    <img :src="logo" width="110" alt="logo"/>
  </div>

  <header class="flex flex-row gap-2 items-center justify-between px-10 my-2">
    <div class="flex flex-row gap-3 items-center">
      <rpm-button
          color-class="text-theme"
          font-class="text-4xl"
          icon="fa-solid fa-circle-user"
          @click="$drop('profile-actions', $event)"
      ></rpm-button>

      <RpmDrop ref="profile-actions" class="flex flex-col gap-2 p-2 text-default dark:text-white">
        <router-link :to="{name:'ChangePassword'}"
                     class="transition-all p-2 text-sm hover:bg-black/5 dark:hover:bg-white/5 rounded">
          Alterar Senha
        </router-link>
        <a @click="logout"
           class="transition-all cursor-pointer p-2 text-sm hover:bg-black/5 dark:hover:bg-white/5 rounded">
          Sair
        </a>
      </RpmDrop>

      <div class="flex flex-col h-full text-xs">
        <span>
          Olá, <b>{{ $user.person.name }}</b>
        </span>
        <span>
          <span v-for="(role, idx) in $user.roles" class="first-letter:uppercase">
            {{
              role +
              (idx < ($user.roles.length - 1) ? ', ' : '')
            }}
          </span>
        </span>
        <span class="first-letter:uppercase">
          <span v-for="(item, index) in $user.person.collaborator.collaborations" :key="index" v-if="$user.person.collaborator.collaborations">
            {{
              item.acronym + (index < ($user.person.collaborator.collaborations.length - 1) ? ', ' : '')
            }}
          </span>
          <span v-else>
          {{ $user.person.collaborator.organization.acronym }}
          </span>
        </span>
      </div>
    </div>

    <div class="flex flex-row gap-2 items-center">
      <rpm-button
        icon="fa-solid fa-magnifying-glass"
        font-class="text-lg"
        class="w-9 h-9 rounded"
        @click="$emit('search')"
      ></rpm-button>

      <rpm-button
          icon="fa-solid fa-plus"
          font-class="text-lg"
          class="w-9 h-9 rounded"
          :to="{name: 'ServicesStore'}"
      ></rpm-button>
    </div>
  </header>
</template>


<script>

import RpmDrop from "#components/RpmDrop";
import logo from "@/src/assets/img/portal156.png";

export default {
  name: "HomeHeader",
  emits: ["search"],
  components: {
    RpmDrop
  },
  data() {
    return {
      logo
    };
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    }
  },
};
</script>
